<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" v-model="liveFilters.patientInsurance" :items="filterListData.patientInsuranceList" item-text="name" item-value="id" label="Payer" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.spp" :items="filterListData.sppList" item-text="name" item-value="id" label="SPP" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.patientHcp" :items="filterListData.patientHcpList" item-text="name" item-value="id" label="Prescriber" multiple outline hide-details />
      <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="stateSelected" />
      <loader v-if="isFiltering.filterList" />
    </template>
    <SPCoreDonutChart
      class="col-sm-12 col-lg-6 p-4"
      title="Patients in Queue Breakout"
      :data="patientsDonutChartData"
      :filterObject="mergeFilter({ payer: null })"
      clickText="PATIENT LIST"
      :isFiltering="isFiltering.patients"
      :selected="liveFilters.payer"
      @refresh-data="loadPatientsData"
      @checked-changed="patientsSelected"
    />
    <SPCoreAlertNotifications
      class="col-sm-12 col-lg-6 p-4"
      title="Alert Notifications"
      :data="alertNotificationsData"
      :filterObject="mergeFilter({ prescriber: null })"
      :isFiltering="isFiltering.alertNotifications"
      @refresh-data="loadAlertNotificationsData"
    />
    <SPCoreBarChart
      class="col-sm-12 col-lg-6 p-4"
      title="Days Waiting"
      :data="daysWaitingBarChartData"
      :filterObject="mergeFilter({ daysWaiting: null })"
      :isFiltering="isFiltering.daysWaiting"
      :selected="liveFilters.daysWaiting"
      nameField="name"
      valueField="value"
      @refresh-data="loadDaysWaitingData"
      @checked-changed="daysWaitingSelected"
    />
    <SPCoreHorizontalBarChart
      class="col-sm-12 col-lg-6 p-4"
      title="Last Status"
      :data="lastStatusBarChartData"
      :filterObject="mergeFilter({ lastStatus: null })"
      :isFiltering="isFiltering.lastStatus"
      :selected="liveFilters.lastStatus"
      nameField="name"
      height:="300px"
      valueField="value"
      @refresh-data="loadLastStatusData"
      @checked-changed="lastStatusSelected"
    />
    <SPCoreLineAreaChart
      class="col-sm-12 col-lg-6 p-4"
      title="Time to First Fill"
      :data="timeToFirstFillData"
      :filterObject="mergeFilter({ timeToFirstFill: null })"
      :isFiltering="isFiltering.timeToFirstFill"
      :selected="liveFilters.timeToFirstFill"
      @refresh-data="loadTimeToFirstFillData"
      @checked-changed="timeToFirstFillSelected"
    />
    <SPCoreLineAreaChart
      class="col-sm-12 col-lg-6 p-4"
      title="Time to Benefits Investigation"
      :data="timeToBenefitsInvestigationData"
      :filterObject="mergeFilter({ timeToBenefitsInvestigation: null })"
      :isFiltering="isFiltering.timeToBenefitsInvestigation"
      :selected="liveFilters.timeToBenefitsInvestigation"
      @refresh-data="loadTimeToBenefitsInvestigationData"
      @checked-changed="timeToBenefitsInvestigationSelected"
    />
    <SPCoreLineChart class="col-sm-12 col-lg-6 p-4" title="Initial Fill Rate" :data="initialFillRateData" :isFiltering="isFiltering.initialFillRate" @refresh-data="loadInitialFillRateData" />
    <SPCoreLineChart class="col-sm-12 col-lg-6 p-4" title="Refill Fill Rate" :data="refillFillRateData" :isFiltering="isFiltering.refillFillRate" @refresh-data="loadRefillFillRateData" />
  </SPCoreShell>
</template>

<script>
import axios from '../../axios';
import { getDemographics } from '../../libraries/cohorts';
import { stringifyLiveFilters } from '../../libraries/liveFilters';
import VTreeselect from '@riophae/vue-treeselect';
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import SPCoreDonutChart from '../../components/spcore/SPCoreDonutChart.vue';
import SPCoreAlertNotifications from '../../components/spcore/SPCoreAlertNotifications.vue';
import SPCoreBarChart from '../../components/spcore/SPCoreBarChart.vue';
import SPCoreHorizontalBarChart from '../../components/spcore/SPCoreHorizontalBarChart.vue';
import SPCoreLineAreaChart from '../../components/spcore/SPCoreLineAreaChart.vue';
import SPCoreLineChart from '../../components/spcore/SPCoreLineChart.vue';
import { mergeFilters } from '../../libraries/common';
export default {
  title: 'Frm Summary',
  components: { VTreeselect, SPCoreDonutChart, SPCoreAlertNotifications, SPCoreBarChart, SPCoreHorizontalBarChart, SPCoreLineAreaChart, SPCoreLineChart, SPCoreShell, },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: { area: {} },
      isFiltering: {},
      cancelRequest: {},
      patientsDonutChartData: [
        { name: 'New', value: 0 },
        { name: 'Refill', value: 0 }
      ],
      alertNotificationsData: [
        { text: 'New Prescriber Alerts', value: 0, link: { text: 'Provider List' }, alert: true },
        { text: 'New Patient Alerts', value: 0, link: { text: 'Patient List' }, alert: true }
      ],
      patientAlertsData: [
        { text: 'Missing info', value: 5, link: { text: 'Patient list', url: 'PatientList' }, alert: 'You should consider what you sould do.' },
        { text: 'BI (+10 Days)', value: 8 },
        { text: 'Bridge Product', value: 12 },
        { text: 'Gap Days', value: null },
      ],
      daysWaitingBarChartData: [],
      lastStatusBarChartData: [],
      timeToFirstFillData: { data: {}, labels: [] },
      timeToBenefitsInvestigationData: { data: {}, labels: [] },
      initialFillRateData: { datasets: [{ data: [] }], labels: [] },
      refillFillRateData: { datasets: [{ data: [] }], labels: [] },
      filterListData: {},
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
    }
  },
  methods: {
    mergeFilter(obj) {
      return mergeFilters(this.liveFilters, obj);
    },
    loadPatientsData(filterObject) {
      if (this.cancelRequest.patients)
        this.cancelRequest.patients();
      this.$set(this.isFiltering, 'patients', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "PatientsInQueueBreakout",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.patients = c)
      }).then((response) => {
        this.patientsDonutChartData = Object.keys(response.data)
          .filter(f => f !== 'patient')
          .map(key => ({
            filterValue: key,
            name: key.capitalize(),
            value: response.data[key],
          }))
        this.isFiltering.patients = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.patients = false;
          this.disableIfTimeout(error);
        }
      });
    },
    patientsSelected(event) {
      var shouldAdd = !(this.liveFilters.payer || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'payer', (this.liveFilters.payer || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.payer.push(event.filterValue);
    },
    loadAlertNotificationsData() {
      if (this.cancelRequest.alertNotifications)
        this.cancelRequest.alertNotifications();
      this.$set(this.isFiltering, 'alertNotifications', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "AlertNotification",
        ...stringifyLiveFilters(this.liveFilters),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.alertNotifications = c)
      }).then((response) => {
        this.alertNotificationsData = [
          { text: 'New Prescriber Alerts', value: response.data.newPrescribers, link: { text: 'Provider List' }, alert: true },
          { text: 'New Patient Alerts', value: response.data.newPatients, link: { text: 'Patient List' }, alert: true }
        ];
        this.isFiltering.alertNotifications = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.alertNotifications = false;
          this.disableIfTimeout(error);
        }
      });
    },
    loadDaysWaitingData(filterObject) {
      if (this.cancelRequest.daysWaiting)
        this.cancelRequest.daysWaiting();
      this.$set(this.isFiltering, 'daysWaiting', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "DaysWaiting",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.daysWaiting = c)
      }).then((response) => {
        var translations = {
          days_0_To_7: '0-7 Days',
          days_8_To_14: '8-14 Days',
          days_15_To_28: '15-28 Days',
          days_29_To_42: '29-42 Days',
          days_43_To_56: '43-56 Days',
          days_Greater_57: '57+ Days',
        };

        this.daysWaitingBarChartData = Object.keys(response.data)
          .map(key => ({
            filterValue: key,
            name: translations[key],
            value: response.data[key],
          }))
        this.isFiltering.daysWaiting = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.daysWaiting = false;
          this.disableIfTimeout(error);
        }
      });
    },
    daysWaitingSelected(event) {
      var shouldAdd = !(this.liveFilters.daysWaiting || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'daysWaiting', (this.liveFilters.daysWaiting || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.daysWaiting.push(event.filterValue);
    },
    loadLastStatusData(filterObject) {
      if (this.cancelRequest.lastStatus)
        this.cancelRequest.lastStatus();
      this.$set(this.isFiltering, 'lastStatus', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "LastStatus",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.lastStatus = c)
      }).then((response) => {
        this.lastStatusBarChartData = Object.keys(response.data)
          .map(key => ({
            filterValue: key,
            name: key.capitalize(),
            value: response.data[key],
          }))
        this.isFiltering.lastStatus = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.lastStatus = false;
          this.disableIfTimeout(error);
        }
      });
    },
    lastStatusSelected(event) {
      var shouldAdd = !(this.liveFilters.lastStatus || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'lastStatus', (this.liveFilters.lastStatus || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.lastStatus.push(event.filterValue);
    },
    loadTimeToFirstFillData(filterObject) {
      if (this.cancelRequest.timeToFirstFill)
        this.cancelRequest.timeToFirstFill();
      this.$set(this.isFiltering, 'timeToFirstFill', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "TimeToFirstFill",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.timeToFirstFill = c)
      }).then((response) => {
        var emptyData = new Array(22).fill(0).reduce((acc, f, ind) => { acc[ind] = 0; return acc; }, []);
        var data = response.data.reduce((acc, f) => {
          if (f.noOfDays >= 21) {
            acc[21] += f.patientCount;
          } else {
            acc[f.noOfDays] += f.patientCount;
          }
          return acc;
        }, emptyData);
        this.timeToFirstFillData = {
          // @ts-ignore
          labels: Object.keys(data).head().concat(['>=21', '>=21']),
          data: {
            Patients: Object.keys(data).map(key => ({ x: key, y: data[key] })).concat({ x: '22', y: data[21] })
          },
          originalData: response.data,
          pieces: [
            { gt: 0, lt: 7, color: 'green' },
            { gt: 7, lt: 13, color: 'yellow' },
            { gt: 13, lt: 20, color: 'orange' },
            { gt: 21, lt: 22, color: 'red' }
          ],
        }
        this.isFiltering.timeToFirstFill = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.timeToFirstFill = false;
          this.disableIfTimeout(error);
        }
      });
    },
    timeToFirstFillSelected(event) {
      var shouldAdd = !(this.liveFilters.timeToFirstFill || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'timeToFirstFill', (this.liveFilters.timeToFirstFill || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.timeToFirstFill.push(event.filterValue);
    },
    loadTimeToBenefitsInvestigationData(filterObject) {
      if (this.cancelRequest.timeToBenefitsInvestigation)
        this.cancelRequest.timeToBenefitsInvestigation();
      this.$set(this.isFiltering, 'timeToBenefitsInvestigation', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "TimeToBenefitsInvestigation",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.timeToBenefitsInvestigation = c)
      }).then((response) => {
        var emptyData = new Array(22).fill(0).reduce((acc, f, ind) => { acc[ind] = 0; return acc; }, []);
        var data = response.data.reduce((acc, f) => {
          if (f.noOfDays >= 21) {
            acc[21] += f.patientCount;
          } else {
            acc[f.noOfDays] += f.patientCount;
          }
          return acc;
        }, emptyData);
        this.timeToBenefitsInvestigationData = {
          // @ts-ignore
          labels: Object.keys(data).head().concat(['>=21', '>=21']),
          data: {
            Patients: Object.keys(data).map(key => ({ x: key, y: data[key] })).concat({ x: '22', y: data[21] })
          },
          originalData: response.data,
          pieces: [
            { gt: 0, lt: 7, color: 'green' },
            { gt: 7, lt: 13, color: 'yellow' },
            { gt: 13, lt: 20, color: 'orange' },
            { gt: 21, lt: 22, color: 'red' }
          ],
        }
        this.isFiltering.timeToBenefitsInvestigation = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.timeToBenefitsInvestigation = false;
          this.disableIfTimeout(error);
        }
      });
    },
    timeToBenefitsInvestigationSelected(event) {
      var shouldAdd = !(this.liveFilters.lastStatus || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'lastStatus', (this.liveFilters.lastStatus || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.lastStatus.push(event.filterValue);
    },
    loadFilterListData() {
      if (this.cancelRequest.filterList)
        this.cancelRequest.filterList();
      this.$set(this.isFiltering, 'filterList', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "FilterListData",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.filterList = c)
      }).then((response) => {
        this.filterListData = response.data;
        this.isFiltering.filterList = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.filterList = false;
          this.disableIfTimeout(error);
        }
      });
    },
    loadInitialFillRateData() {
      if (this.cancelRequest.initialFillRate)
        this.cancelRequest.initialFillRate();
      this.$set(this.isFiltering, 'initialFillRate', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "InitialFillRate",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.initialFillRate = c)
      }).then((response) => {
        this.initialFillRateData = {
          datasets: [{
            data: response.data.map(f => ({ y: f.percentage })),
            label: "Initial Fill Rate"
          }],
          labels: response.data.map(f => `${f.month}-${f.year}`),
        };
        this.isFiltering.initialFillRate = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.initialFillRate = false;
          this.disableIfTimeout(error);
        }
      });
    },
    loadRefillFillRateData() {
      if (this.cancelRequest.refillFillRate)
        this.cancelRequest.refillFillRate();
      this.$set(this.isFiltering, 'refillFillRate', true);
      axios.post('/SPCore/FrmSummary/GetPatientsInQueueBreakout', {
        runId: this.runId,
        component: "RefillFillRate",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.initialFillRate = c)
      }).then((response) => {
        this.refillFillRateData = {
          datasets: [{
            data: response.data.map(f => ({ y: f.percentage })),
            label: "Refill Fill Rate"
          }],
          labels: response.data.map(f => `${f.month}-${f.year}`),
        };
        this.isFiltering.refillFillRate = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.refillFillRate = false;
          this.disableIfTimeout(error);
        }
      });
    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    disableIfTimeout(error) {
      if (error.response.status === 504) {
        this.alert('Error', 'Loading of data failed. Please reload page to try loading data again.');
      }
    },
  },
  computed: {
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCoreFrmSummary'] = this;
    this.loadFilterListData();
  },
}
</script>
